import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import DataContainer from '../../Shared/DataContainer';
import SelectInput from '../../Shared/SelectInput';
import LoadingButton from '../../Shared/LoadingButton';
import TextInput from '../../Shared/TextInput';
import { AsYouType } from 'libphonenumber-js';
import { can } from '../../utils';

const ProceedCart = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          cart: (data.cart)?data.cart.id:0,
          details: (data.cart)?data.cart.details:[],
          pay_method: '',
          pickup: (data.cart)?data.cart.pickup:'',
          delivery: (data.cart)?data.cart.delivery:'',
          delivery_cost: (data.cart)?data.cart.delivery_cost:0,
          is_pickup: (data.cart)?data.cart.is_pickup:true,
          is_delivery: (data.cart)?data.cart.is_delivery:false,
          name: data.cart.receiver.name || '',
          phone: data.cart.receiver.phone || '',
          address: data.cart.receiver.address || '',
          coupon: '',
          terms_accept: true,
          canProced: true,
     });

     function handleChange(e, index) {
          e.persist();
          const key = e.target.name;
          let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          if(key == 'phone'){
               let number = new AsYouType('HT').input(value);
               if(value.length < 16){
                    if(number.split(' ')[0] != '+509'){
                         number = `+509 ${number}`;
                    }
                    value = number;
               }else{
                    value = values.phone;
               }
          }
          setValues(values => ({
               ...values,
               [key]: value,
          }));
     }

     function handleChangeOption(e) {
          const key = e.target.name;
          let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          let is_pickup = values.is_pickup;
          let is_delivery = values.is_delivery;
          let delivery_cost = values.delivery_cost;
          let delivery = values.delivery;
          if(value == 'is_pickup'){
               is_pickup = true;
               is_delivery = false;
               delivery_cost = 0;
               delivery: ''
          }else{
               is_delivery = true;
               is_pickup = false;
          }
          setValues(values => ({
               ...values,
               is_pickup: is_pickup,
               is_delivery: is_delivery,
               delivery_cost: delivery_cost,
               delivery: delivery
          }));
     }

     function handleChangeDelivery(e) {
          e.preventDefault();
          let value = e.target.value;
          let deliver = data.cart.deliveries.find((deliv, i) => {
               return deliv.deliver == value;
          });
          setValues(values => ({
               ...values,
               delivery_cost: deliver.amount,
               delivery: deliver.deliver
          }));
     }

     function enableSub(){
          let canProced = (values.pay_method != '' && (values.pickup != '' || values.delivery != '') && values.name != '' && values.phone != '') ? true : false;
          setValues(values => ({
               ...values,
               canProced: canProced
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          let canProced = (values.pay_method != '' && (values.pickup != '' || values.delivery != '') && values.name != '' && values.phone != '' && values.terms_accept) ? true : false;
          console.log('canProced', canProced);
          if(canProced){
               setSending(true);
               Inertia.post(route('payment.prepare', data.cart.id), values).then(() => {
                    setSending(false);
               });
          }
          return false;
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>{data.caption.title}</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">{data.caption.title}</span>
               </div>
               {!data.cart && (<div className="bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center" dangerouslySetInnerHTML={{ __html: data.caption.empty}}></div>)}
               {data.cart && (<div className="col-span-12 flex my-6">
                    <div className="w-full flex flex-col w-full p-8 text-gray-800 bg-white shadow-lg pin-r pin-y">
                         <form onSubmit={handleSubmit}>
                              <div className="flex-1">
                                   <table className="w-full text-sm lg:text-base" cellSpacing="0">
                                        <thead>
                                             <tr className="h-12 uppercase">
                                                  <th className="hidden md:table-cell"></th>
                                                  <th className="text-left">{data.caption.product}</th>
                                                  <th className="lg:text-right text-left pl-5 lg:pl-0">
                                                       <span className="lg:hidden" title="Quantity">{data.caption.short_qty}</span>
                                                       <span className="hidden lg:inline">{data.caption.quantity}</span>
                                                  </th>
                                                  <th className="hidden text-right md:table-cell">{data.caption.price}</th>
                                                  <th className="text-right">{data.caption.total_price}</th>
                                             </tr>
                                        </thead>
                                        <tbody>
                                             {values.details.map(({id, name, code, product, quantity, currency, price, newprice, packs, image, update}, i) => {
                                                  return <tr className="pt-4 border-b border-gray-300" key={id}>
                                                       <td className="hidden pb-4 md:table-cell">
                                                            <a href="#">
                                                                 {image && (<img src={image} alt={name} className="w-12 rounded" alt="Thumbnail" />)}
                                                                 {!image && (<img className="w-12" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                                            </a>
                                                       </td>
                                                       <td>
                                                            <a href="#">
                                                                 <p className="mb-2 md:ml-4">{name} <span className="text-xs text-gray-500">({code})</span></p>
                                                                 {packs && (<span className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</span>)}
                                                            </a>
                                                       </td>
                                                       <td className="justify-center mt-6 text-center font-semibold">
                                                            {quantity}
                                                       </td>
                                                       <td className="hidden text-right md:table-cell">
                                                            {(newprice != 0) && (<div>
                                                                 <span className="w-full text-sm text-gray-400 font-medium line-through">{currency} {price.toFixed(2)}</span><br />
                                                                 <span className="w-full text-sm lg:text-base font-medium text-emerald-700">{currency} {newprice.toFixed(2)}</span>
                                                            </div>)}
                                                            {(newprice == 0) && (<div>
                                                                 <span className="w-full text-sm lg:text-base font-medium">{currency} {price.toFixed(2)}</span><br />
                                                            </div>)}
                                                       </td>
                                                       <td className="text-right">
                                                            {(newprice != 0) && (<span className="text-sm lg:text-base font-medium">{currency} {(newprice * quantity).toFixed(2)}</span>)}
                                                            {(newprice == 0) && (<span className="text-sm lg:text-base font-medium">{currency} {(price * quantity).toFixed(2)}</span>)}
                                                       </td>
                                                  </tr>
                                             })}
                                        </tbody>
                                   </table>
                                   <div className="w-full md:flex md:justify-between my-2">
                                        <div className="w-full md:w-1/2"></div>
                                        <div className="w-full md:w-1/2 rounded bg-gray-100 p-4">
                                             <div className={`flex justify-between border-b ${(!values.is_delivery || !data.cart.enable_delivery)?'hidden':''}`}>
                                                  <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-md font-bold text-center text-gray-800">
                                                       {data.caption.delivery}
                                                  </div>
                                                  <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                       {data.cart.currency} {values.delivery_cost.toFixed(2)}
                                                  </div>
                                             </div>
                                             <div className="flex justify-between">
                                                  <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-md font-bold text-center text-gray-800">
                                                       {data.caption.total}
                                                  </div>
                                                  <div className="lg:px-4 lg:py-2 m-2 lg:text-md font-bold text-center text-gray-900">
                                                       {data.cart.currency} {(values.is_delivery && data.cart.enable_delivery)?(values.delivery_cost + data.cart.amount).toFixed(2):data.cart.amount.toFixed(2)}
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                                   <hr />
                                   <div className="my-4 mt-6 -mx-2 flex w-full md:w-3/4 md:mx-auto">
                                        <div className="w-full lg:px-2">
                                             <div className="w-full md:flex md:justify-between">
                                                  <p className="w-full md:w-1/2 mb-2 font-bold text-gray-700">{data.caption.pickup}{data.cart.enable_delivery?` / ${data.caption.delivery}`:''}</p>
                                                  <div className={`w-full md:w-1/2 flex justify-between mb-3 ${!data.cart.enable_delivery?'hidden':''}`}>
                                                       <label className="flex items-center bg-emerald-200 p-2 rounded" htmlFor="option">
                                                            <input name="option" className="form-checkbox" type="radio" value={'is_pickup'} checked={values.is_pickup} onChange={handleChangeOption}/>
                                                            <span className="ml-2 text-md text-emerald-700 font-medium">{data.caption.pickup}</span>
                                                       </label>
                                                       <label className="flex items-center bg-yellow-200 p-2 rounded" htmlFor="option">
                                                            <input name="option" className="form-checkbox" type="radio" value={'is_delivery'} checked={values.is_delivery} onChange={handleChangeOption}/>
                                                            <span className="ml-2 text-md text-yellow-700 font-medium">{data.caption.delivery}</span>
                                                       </label>
                                                  </div>
                                             </div>

                                             <div className="w-full md:flex md:justify-between">
                                                  <div className="w-full md:w-1/2"></div>
                                                  <div className="w-full md:w-1/2">
                                                       <div className={`mb-2 ${!values.is_pickup?'hidden':''}`}>
                                                            <p className="mb-2 text-md font-semibold text-gray-500">{data.caption.pickUp_location}</p>
                                                            <ul className="list-none">
                                                                 {data.cart.pickup_address.map(({id, name, address}) => {
                                                                      return <li className={`p-2 mt-2 rounded bg-gray-100 hover:bg-emerald-200 hover:shadow-md`} key={`p${id}`}>
                                                                           <label className="flex items-center" htmlFor="pickup">
                                                                                <input name="pickup" className="form-checkbox" type="radio" value={id} onChange={handleChange}/>
                                                                                <span className="ml-2 text-md text-gray-700 font-bold">{name}</span>
                                                                                <span className="ml-2 text-sm text-gray-500">{address}</span>
                                                                           </label>
                                                                      </li>
                                                                 })}
                                                            </ul>
                                                       </div>
                                                       <div className={`mb-2 ${(!values.is_delivery || !data.cart.enable_delivery)?'hidden':''}`}>
                                                            <SelectInput
                                                                 className="flex-shrink w-full inline-block relative mr-2"
                                                                 label={data.caption.delivery_location}
                                                                 name="delivery"
                                                                 must={true}
                                                                 errors={errors.delivery}
                                                                 value={values.delivery}
                                                                 onChange={handleChangeDelivery}
                                                            >
                                                                 <option value="">{data.caption.delivery_location}</option>
                                                                 {data.cart.deliveries.map(({deliver, deliver_to, amount}, i) => {
                                                                      return <option key={`del${i}`} value={deliver}>{deliver_to}</option>
                                                                 })}
                                                            </SelectInput>
                                                       </div>
                                                  </div>
                                             </div>

                                             <div className="w-full md:flex md:justify-between pt-4 border-t">
                                                  <div className="w-full md:w-1/2">
                                                       <p className="mb-2 font-bold text-gray-600">{(!values.is_delivery || !data.cart.enable_delivery)?data.caption.pickUp_title:data.caption.delivery_title}</p>
                                                       <p className="mb-2 text-md font-semibold text-gray-500">{data.caption.pickUp_subtitle}</p>
                                                       <p className="mb-4 text-sm text-gray-500 pr-4 text-justify">{data.caption.pickUp_description}</p>
                                                  </div>
                                                  <div className="w-full md:w-1/2">
                                                       <TextInput
                                                            className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                            label={data.caption.fnameId}
                                                            name="name"
                                                            type="text"
                                                            disable={false}
                                                            readonly={false}
                                                            errors={errors.name}
                                                            value={values.name}
                                                            onChange={handleChange}
                                                       />
                                                       <TextInput
                                                            className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                            label={data.caption.phone}
                                                            name="phone"
                                                            type="text"
                                                            disable={false}
                                                            readonly={false}
                                                            errors={errors.phone}
                                                            value={values.phone}
                                                            onChange={handleChange}
                                                       />
                                                       <TextInput
                                                            className={`form-input rounded-md shadow-sm mt-4 block w-full ${(!values.is_delivery || !data.cart.enable_delivery)?'hidden':''}`}
                                                            label={data.caption.address}
                                                            name="address"
                                                            type="text"
                                                            disable={false}
                                                            readonly={false}
                                                            errors={errors.address}
                                                            value={values.address}
                                                            onChange={handleChange}
                                                       />
                                                  </div>
                                             </div>

                                             <div className="w-full md:flex md:justify-between mt-2 pt-4 border-t">
                                                  <div className="w-full md:w-1/2">
                                                       <p className="font-bold text-gray-700">{data.caption.pay_method}</p>
                                                  </div>
                                                  <div className="w-full md:w-1/2">
                                                       <ul className="list-none mt-2">
                                                            {data.cart.pay_method.map((method) => {
                                                                 return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md`} key={method.name}>
                                                                      <label className="flex items-center" htmlFor="moncash">
                                                                           <input name="pay_method" className="form-checkbox" type="radio" value={method.name} onChange={handleChange}/>
                                                                           <span className="ml-2 text-sm text-gray-800">
                                                                                <img src={method.logo} alt={method.name} className="w-10" />
                                                                           </span>
                                                                           <span className="ml-2 text-md font-bold text-gray-500">{method.name}</span>
                                                                      </label>
                                                                 </li>
                                                            })}
                                                       </ul>
                                                       <div className="flex justify-between">
                                                            <TextInput
                                                                 className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                                 label="Coupon"
                                                                 name="coupon"
                                                                 type="text"
                                                                 disable={false}
                                                                 readonly={false}
                                                                 errors={errors.coupon}
                                                                 value={values.coupon}
                                                                 onChange={handleChange}
                                                            />
                                                       </div>
                                                  </div>
                                             </div>

                                             <div className="w-full md:flex md:justify-between mt-2 pt-4 border-t">
                                                  <div className="w-full md:w-1/2"></div>
                                                  <div className="w-full md:w-1/2 rounded bg-gray-100 p-4">
                                                       <div className={`flex justify-between border-b ${(!values.is_delivery || !data.cart.enable_delivery)?'hidden':''}`}>
                                                            <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-md font-semidbold text-center text-gray-600">
                                                                 {data.caption.delivery}
                                                            </div>
                                                            <div className="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                                                 {data.cart.currency} {values.delivery_cost.toFixed(2)}
                                                            </div>
                                                       </div>
                                                       <div className="flex justify-between border-b">
                                                            <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-md font-bold text-center text-gray-800">
                                                                 {data.caption.total}
                                                            </div>
                                                            <div className="lg:px-4 lg:py-2 m-2 lg:text-md font-bold text-center text-gray-900">
                                                                 {data.cart.currency} {(values.is_delivery && data.cart.enable_delivery)?(values.delivery_cost + data.cart.amount).toFixed(2):data.cart.amount.toFixed(2)}
                                                            </div>
                                                       </div>
                                                       <div className="flex justify-between mt-6">
                                                            <label className="form-input rounded-md mt-4 block w-full" htmlFor="perms">
                                                                <input name="terms_accept" className="form-checkbox" type="checkbox" value={values.terms_accept} checked={values.terms_accept} onChange={handleChange}/>
                                                                <a href={route('site.get.tos')} target="_blank" className="ml-2 text-sm text-gray-800 hover:underline">{data.caption.tnc}</a>
                                                           </label>
                                                       </div>
                                                       <LoadingButton type="submit" loading={sending} className={`flex justify-center w-full px-10 py-3 mt-4 font-medium text-white uppercase bg-emerald-800 rounded-full shadow item-center hover:bg-emerald-600 focus:shadow-outline focus:outline-none ${(!values.canProced)?'opacity-50 cursor-not-allowed':''}`}>
                                                            {data.caption.continue}
                                                       </LoadingButton>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </form>
                    </div>
               </div>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
ProceedCart.layout = page => <UserLayout children={page} header={'Proceed Checkout'} />;

export default ProceedCart;
